import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import GameCard from "../GameCard";

type BigTilesLayoutProps = {
  gameIds: string[];
  isNewlyGenerated?: boolean;
};

const BigTilesLayout: FC<BigTilesLayoutProps> = ({
  gameIds,
  isNewlyGenerated,
}) => {
  const fiveGameIds = gameIds?.slice(0, 5) || [];

  return (
    <SpaceBetweenCenter gap={2}>
      {fiveGameIds.map((gameId) => (
        <GameCard
          key={gameId}
          gameId={gameId}
          imageWidth="175px"
          imageHeight="124px"
          maxWidth="175px"
          titleVariant="bodySMedium"
          subtitleVariant="bodyXSSemiBold"
          isNewlyGenerated={isNewlyGenerated}
        />
      ))}
    </SpaceBetweenCenter>
  );
};

export default BigTilesLayout;
